import { render } from "./HappinessModal.vue?vue&type=template&id=438be073&scoped=true"
import script from "./HappinessModal.vue?vue&type=script&lang=js"
export * from "./HappinessModal.vue?vue&type=script&lang=js"

import "./HappinessModal.vue?vue&type=style&index=0&id=438be073&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438be073"]])

export default __exports__